export const alphabeticalSort = (array, comparisonProperty) => {
    return array.sort((a, b) => {
        if (a[comparisonProperty] < b[comparisonProperty]) return -1
        if (a[comparisonProperty] > b[comparisonProperty]) return 1
        return 0
    })
}